export const CANCELLATION_POLICIES_QUERY = `
  query getAllpolicies($filters: String!) {
    getEntityWithRelations(
      entityType: POLICY,
      filters: $filters,
      fields: ["id", "name", "code", "crsCode", "isActive"],
      relations: [
        { targetEntity: CANCELLATION_WINDOW },
        { targetEntity: RATE_PLAN }
      ]
    ) {
      success
      message
      policies {
        id policyName crsCode isActive attachedRateplans
        htCancellationWindows {
          id windowIndex cancelPaymentType cancelPaymentAmount
          startValue endValue startStr endStr isActive startUnit endUnit
        }
      }
      totalCount page size totalPages errors
    }
  }
`;

export const TAXES_QUERY = `
  query getAllTaxes($filters: String!) {
    getEntityWithRelations(
      entityType: PROPERTY_TAX,
      filters: $filters,
      fields: ["id", "name", "isActive", "taxType", "payAtProperty", "chargeBasis", "chargeFrequency", "chargeAmount", "chargeType", "currencyCode"],
      relations: []
    ) {
      success
      message
      entity
      relations {
        entityType
        entities
      }
      totalCount
      page
      size
      totalPages
      errors
    }
  }
`;

export const ROOMTYPES_QUERY = `
  query getAllRoomTypes($filters: String!) {
    getEntityWithRelations(
      entityType: ROOMTYPE,
      filters: $filters,
      fields: ["id", "displayName", "code", "isActive", "minAdultOccupancy", "maxAdultOccupancy", "minChildOccupancy", "maxChildOccupancy", "totalMaxOccupancy"],
      relations: []
    ) {
      success
      message
      entity
      relations {
        entityType
        entities
      }
      totalCount
      page
      size
      totalPages
      errors
    }
  }
`;

// `seasonalPolicies` is a LIST per policy — one entry per date range the policy
// applies to. That plurality is the point: the previous singular `seasonalPolicy`
// could only ever carry one range, which is why a hotel with three saw one.
//
// Note this query omits the `fields` argument its siblings pass; the selection
// set below names what comes back.
export const SEASONAL_POLICIES_QUERY = `
  query getAllpolicies($filters: String!) {
    getEntityWithRelations(
      entityType: POLICY,
      filters: $filters,
      relations: [
        { targetEntity: CANCELLATION_WINDOW },
        { targetEntity: RATEPLAN_SMART_POLICY }
      ]
    ) {
      success
      message
      policies {
        id
        policyName
        crsCode
        isActive
        htCancellationWindows {
          id
          windowIndex
          cancelPaymentType
          cancelPaymentAmount
          startValue
          endValue
          startStr
          endStr
          isActive
          startUnit
          endUnit
        }
        seasonalPolicies {
          id
          startDate
          endDate
          attachedRateplans
        }
      }
      totalCount
      page
      size
      totalPages
      errors
    }
  }
`;
